import Text from '../../Text';
import styles from '../contingutEstatic.module.scss';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';

interface TextComponentProps {
    text: string;
    estil?: string;
    mida?: string;
    className?: string;
}

const TextComponent: React.FC<TextComponentProps> = (props) => {
    const { text, estil, mida, className } = props;
    const stylesText = clsx(
        styles.text,
        !__isEmpty(estil) && styles[estil as string],
        !__isEmpty(mida) && styles[mida as string],
        !__isEmpty(className) && className
    );
    return <Text text={text} dataTestId='contingut-parsejat-text' className={stylesText} />;
};

export default TextComponent;
